import { render, staticRenderFns } from "./preAlipayAndRealNameDialog.vue?vue&type=template&id=727ef877&scoped=true"
import script from "./preAlipayAndRealNameDialog.vue?vue&type=script&lang=js"
export * from "./preAlipayAndRealNameDialog.vue?vue&type=script&lang=js"
import style0 from "./preAlipayAndRealNameDialog.vue?vue&type=style&index=0&id=727ef877&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ef877",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727ef877')) {
      api.createRecord('727ef877', component.options)
    } else {
      api.reload('727ef877', component.options)
    }
    module.hot.accept("./preAlipayAndRealNameDialog.vue?vue&type=template&id=727ef877&scoped=true", function () {
      api.rerender('727ef877', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/ozonPrint/components/preAlipayAndRealNameDialog.vue"
export default component.exports